import { z } from 'zod';
/**
 * Default job types seeded when an organization has no custom job types.
 * Single source of truth — consumed by backend domain layer and frontend.
 */
export const DEFAULT_JOB_TYPES = [
    {
        key: 'bookkeeping',
        label: 'Bookkeeping',
        description: 'Regular bookkeeping and reconciliation services.',
        enabled: true,
        displayOrder: 0,
    },
    {
        key: 'confirmation_statement',
        label: 'Confirmation Statement',
        description: 'Annual confirmation statement filing with Companies House.',
        enabled: true,
        displayOrder: 1,
    },
    {
        key: 'management_accounts',
        label: 'Management Accounts',
        description: 'Periodic management accounts preparation and reporting.',
        enabled: true,
        displayOrder: 2,
    },
    {
        key: 'onboarding',
        label: 'Onboarding',
        description: 'New client onboarding and AML compliance.',
        enabled: true,
        displayOrder: 3,
    },
    {
        key: 'other',
        label: 'Other',
        description: 'Other job types not listed above.',
        enabled: true,
        displayOrder: 4,
    },
    {
        key: 'payment_run',
        label: 'Payment Run',
        description: 'Processing and executing payment runs.',
        enabled: true,
        displayOrder: 5,
    },
    {
        key: 'payroll',
        label: 'Payroll',
        description: 'Payroll processing and submissions.',
        enabled: true,
        displayOrder: 6,
    },
    {
        key: 'r_and_d_tax_credits',
        label: 'R&D Tax Credits',
        description: 'Research and development tax relief claims.',
        enabled: true,
        displayOrder: 7,
    },
    {
        key: 'tax_return',
        label: 'Tax Return',
        description: 'Tax return and advisory services.',
        enabled: true,
        displayOrder: 8,
    },
    {
        key: 'vat_return',
        label: 'VAT Return',
        description: 'Quarterly or monthly VAT return filing.',
        enabled: true,
        displayOrder: 9,
    },
    {
        key: 'year_end_accounts',
        label: 'Year End Accounts',
        description: 'Annual accounts preparation and filing.',
        enabled: true,
        displayOrder: 10,
    },
];
export const JobTypeKeySchema = z
    .string()
    .min(1, 'Job type is required')
    .max(100, 'Job type key must be 100 characters or less')
    .regex(/^[a-z0-9]+(?:_[a-z0-9]+)*$/, 'Job type key must be lowercase alphanumeric with underscores (e.g. tax_return)');
//# sourceMappingURL=JobTypeSchemas.js.map